import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-305ec35e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "swiper"
};
var _hoisted_2 = {
  class: "img-box"
};
var _hoisted_3 = {
  class: "text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_image = _resolveComponent("el-image");

  var _component_el_carousel_item = _resolveComponent("el-carousel-item");

  var _component_el_carousel = _resolveComponent("el-carousel");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_carousel, {
    class: "swiper",
    interval: 3000,
    type: "card",
    height: "200px"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.swiperList, function (item, index) {
        return _openBlock(), _createBlock(_component_el_carousel_item, {
          key: index,
          onClick: function onClick($event) {
            return _ctx.swiperPlayerClick(item.targetId, item.targetType);
          }
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(item.typeTitle), 1
            /* TEXT */
            ), _createVNode(_component_el_image, {
              class: "swiper-img",
              src: item.imageUrl
            }, null, 8
            /* PROPS */
            , ["src"])])];
          }),
          _: 2
          /* DYNAMIC */

        }, 1032
        /* PROPS, DYNAMIC_SLOTS */
        , ["onClick"]);
      }), 128
      /* KEYED_FRAGMENT */
      ))];
    }),
    _: 1
    /* STABLE */

  })]);
}